import tw from "twin.macro";

export const SectionHeading = tw.h2`text-3xl sm:text-5xl text-black tracking-wide text-center`

export const Subheading = tw.h5`font-bold text-black`

export const SubheadingPara = tw.h3`font-normal text-black text-sm md:text-xl`

